export default __webpack_public_path__ + "static/O0046-910a624c60610b5bb907e5faedcd90e3.png";